import { ENTERPRISE_CONTROL_BASE } from "../enterprise-control/constants";
import { normalizePortalProductKey } from "./portalEntitlements";

/** Portal head consoles — one route tree per product (Enterprise, Salon, Brand). */
export const ENTERPRISE_ADMIN_BASE = "/nyafaz-enterprise";
export const ENTERPRISE_PORTAL_CONSOLE_PATH = ENTERPRISE_CONTROL_BASE;

export const PORTAL_PRODUCTS = [
  {
    slug: "enterprise",
    productType: "enterprise",
    title: "Enterprise",
    subtitle: "Franchise networks & HQ",
    accent: "#2d5a7b",
    accentDark: "#234a66",
    adminPath: ENTERPRISE_ADMIN_BASE,
    consolePath: ENTERPRISE_CONTROL_BASE,
    nav: [
      { key: "overview", label: "Dashboard", path: "" },
      { key: "organizations", label: "Organizations", path: "organizations" },
    ],
  },
  {
    slug: "salon",
    productType: "nyafaz_salon",
    title: "Nyafaz Salon",
    subtitle: "Single-salon product orgs",
    accent: "#80489a",
    accentDark: "#6b3a82",
    adminPath: "/nyafaz-salon",
    nav: [
      { key: "overview", label: "Overview", end: true },
      { key: "organizations", label: "Organizations", path: "organizations" },
      { key: "analytics", label: "Analytics", path: "analytics" },
    ],
  },
  {
    slug: "brand",
    productType: "nyafaz_brand",
    title: "Nyafaz Brand",
    subtitle: "Brand embed & catalog orgs",
    accent: "#5c3d7a",
    accentDark: "#4a3163",
    adminPath: "/nyafaz-brand",
    nav: [
      { key: "overview", label: "Overview", end: true },
      { key: "organizations", label: "Organizations", path: "organizations" },
      { key: "analytics", label: "Analytics", path: "analytics" },
    ],
  },
];

export const getProductBySlug = (slug) => PORTAL_PRODUCTS.find((p) => p.slug === slug) || null;

export const getProductByType = (productType) => {
  const normalized = normalizePortalProductKey(productType);
  return PORTAL_PRODUCTS.find((p) => p.productType === normalized) || null;
};

export const productConsoleBase = (slug) =>
  slug === "enterprise" ? ENTERPRISE_CONTROL_BASE : `/enterprise-portal/products/${slug}`;
